module.exports = __webpack_public_path__ + "static/img/icon1-7.ce1e3766.png";